export default {
  optins: {},

  loadingOptins: false,
  loadingOptinsFailed: false,
  loadingOptinsSucceeded: false,
  loadingOptinsError: null,

  downloadOptinsUrl: null,
  downloadingOptins: false,
  downloadingOptinsFailed: false,
  downloadingOptinsSucceeded: false,
  downloadingOptinsError: null,

  creatingOptins: false,
  creatingOptinsFailed: false,
  creatingOptinsSucceeded: false,
  creatingOptinsError: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/privacy/state.js